// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__AcWGP","separator":"Footer_separator__R0qVx","buildInfo":"Footer_buildInfo__DB7fk"};